import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Contrast = createReactComponent("Contrast", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["path", {
  d: "M12 18a6 6 0 000-12v12z",
  key: "6cp19i"
}]]]);
export default Contrast;